import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { RequeteStatut } from '../../../entities/requete';
import { ErrorEnum } from '../../../shared/constants/error.constants';
import { ErrorService } from '../../../shared/services/error.service';
import { ROUTES_NAMES } from '../../rattachement.model';
import { RattachementService } from '../../rattachement.service';

@Component({
    selector: 'jhi-rejoindre-dossier',
    templateUrl: './rejoindre-dossier.component.html',
    styleUrls: ['rejoindre-dossier.component.scss']
})
export class RejoindreDossierComponent {

    secretCode: string;

    isDisabled: boolean;

    isLoading: boolean;

    @ViewChild(NgForm) form: NgForm;

    error: {
        code: string;
        requeteId?: string;
        requeteStatus?: RequeteStatut;
    };

    constructor(
        private rattachementService: RattachementService,
        private errorService: ErrorService,
        private router: Router
    ) {
    }

    valider() {
        if (this.form.valid) {
            this.error = null;
            this.isLoading = true;
            this.rattachementService.applyRattachement(this.secretCode)
            .toPromise()
            .then((_res) => {
                    this.rattachementService.trackRattachementSucceedEvent();
                    this.router.navigate([`/rattachement/${ROUTES_NAMES.CONFIRMATION}`]);
                }).catch((err) => {
                    this.isLoading = false;
                    this.processError(err);
                });
        } else {
            this.errorService.markAllControlsAsTouched(this.form);
        }
    }

    private processTechnicalError() {
        this.form.controls['secretCode'].setErrors({invalid: true, 'technical': true});
        if (this.error.code === ErrorEnum.TR_TECHNICAL_ERROR) {
            this.rattachementService.trackRattachementFailedTrTechnicalEvent();
        } else {
            this.rattachementService.trackRattachementFailedTechnicalEvent();
        }
        this.isDisabled = true;
    }

    private processError(err: any): void {
        this.error = err.error;

        if (err.status === 400 && this.error.code === ErrorEnum.SECRET_CODE_SYNTAX_ERROR) {
            this.form.controls['secretCode'].setErrors({ invalid: true, syntax: true });
            this.rattachementService.trackRattachementFailedSyntaxEvent();
        } else if (err.status === 400 && this.error.code === ErrorEnum.SECRET_CODE_SEMANTIC_ERROR) {
            this.form.controls['secretCode'].setErrors({ invalid: true, semantic: true });
            this.rattachementService.trackRattachementFailedSemanticEvent();
        } else if (err.status === 400 && this.error.code === ErrorEnum.SECRET_CODE_ALREADY_ATTACHED) {
            this.processAlreadyAttachedError(this.error);
            this.rattachementService.trackRattachementFailedAlreadyAttachedEvent();
        } else if (err.status === 400 && this.error.code === ErrorEnum.SECRET_CODE_EXPIRED) {
            this.form.controls['secretCode'].setErrors({ invalid: true, expired: true });
            this.rattachementService.trackRattachementFailedExpiredEvent();
        } else {
            this.processTechnicalError();
        }
    }

    private processAlreadyAttachedError(error: any): void {
        if (error.requeteId && error.requeteStatus !== RequeteStatut.EN_ATTENTE_DE_RATTACHEMENT) {
            this.form.controls['secretCode'].setErrors({ invalid: true, 'already-attached-fetchable': true });
        } else if (error.requeteId && error.requeteStatus === RequeteStatut.EN_ATTENTE_DE_RATTACHEMENT) {
            this.form.controls['secretCode'].setErrors({ invalid: true, 'already-attached-listable': true });
        } else {
            this.form.controls['secretCode'].setErrors({ invalid: true, 'already-attached-unknown': true })
        }
    }

    previous() {
        this.router.navigate([`/rattachement/${ROUTES_NAMES.AVERTISSEMENTS}`]);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/rattachement/steps/rejoindre-dossier/rejoindre-dossier.component.ts